(() => {
  const topics = [
    {
      id: 'orders-shipping',
      icon: '01',
      title: 'Orders & Shipping',
      description: 'Questions about shipping methods, delivery times, tracking and orders.',
      groups: [
        {
          title: 'Shipping',
          items: ['shipping-time', 'shipping-methods', 'shipping-cost', 'ocean-shipping']
        },
        {
          title: 'Tracking & Orders',
          items: ['track-order', 'change-address', 'change-cancel-order', 'order-history']
        }
      ]
    },
    {
      id: 'wholesale-discounts',
      icon: '02',
      title: 'Wholesale & Discounts',
      description: 'Volume pricing, automatic cart discounts, and Ocean Shipping savings.',
      groups: [
        {
          title: 'Wholesale Pricing',
          items: ['wholesale-pricing', 'volume-discounts', 'discount-not-apply', 'ocean-discount']
        }
      ]
    },
    {
      id: 'products-availability',
      icon: '03',
      title: 'Products & Availability',
      description: 'Help choosing products, checking materials, colors, sizes and restocks.',
      groups: [
        {
          title: 'Product Help',
          items: ['choose-product', 'out-of-stock', 'color-material-help']
        }
      ]
    },
    {
      id: 'custom-printing-orders',
      icon: '04',
      title: 'Custom Printing & Orders',
      description: 'Logo printing, custom packaging, artwork and quote requests.',
      groups: [
        {
          title: 'Custom Orders',
          items: ['custom-printing', 'print-logo', 'custom-quote']
        }
      ]
    },
    {
      id: 'samples',
      icon: '05',
      title: 'Samples',
      description: 'Sample requests for materials, colors and larger wholesale planning.',
      groups: [
        {
          title: 'Samples',
          items: ['samples-offered', 'sample-shipping-cost', 'sample-before-wholesale', 'sample-help']
        }
      ]
    },
    {
      id: 'order-issues-returns',
      icon: '06',
      title: 'Order Issues & Returns',
      description: 'Damaged items, missing packages, delivered tracking and return questions.',
      groups: [
        {
          title: 'Order Issues',
          items: ['delivered-not-received', 'damaged-wrong-item', 'return-policy']
        }
      ]
    },
    {
      id: 'account-reordering',
      icon: '07',
      title: 'Account & Reordering',
      description: 'Account access, saved addresses, previous orders and repeat purchases.',
      groups: [
        {
          title: 'Account',
          items: ['account-access', 'reorder-products', 'saved-addresses']
        }
      ]
    }
  ];

  const faqs = [
    {
      id: 'shipping-time',
      question: 'How long does shipping take?',
      category: 'orders-shipping',
      subcategory: 'Shipping',
      keywords: 'shipping delivery eta arrive standard express ocean transit business days',
      short_answer: 'Standard Shipping is estimated at 10-12 business days. Express Shipping is a paid upgrade for faster delivery and is estimated at 5-8 business days. Ocean Shipping is estimated at 18-25 days after vessel departure for qualifying planned restocking orders.',
      detail_url: '/policies/shipping-policy',
      detail_label: 'View Shipping Policy',
      priority: 'high',
      show_on_contact: true,
      contact_order: 1
    },
    {
      id: 'shipping-methods',
      question: 'What shipping methods do you offer?',
      category: 'orders-shipping',
      subcategory: 'Shipping',
      keywords: 'shipping method standard express ocean delivery freight',
      short_answer: 'BBJ WRAPS offers Standard Shipping, Express Shipping, and Ocean Shipping. Express Shipping is available at every order value where the destination is supported. Ocean Shipping eligibility depends on the order value after Professional Pricing, destination, and checkout eligibility.',
      detail_url: '/policies/shipping-policy',
      detail_label: 'View Shipping Policy',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'shipping-cost',
      question: 'How much does shipping cost?',
      category: 'orders-shipping',
      subcategory: 'Shipping',
      keywords: 'shipping cost free rate fee standard express paid upgrade 29',
      short_answer: 'Standard Shipping is $9.99 under $29 and free on orders $29+. Express Shipping is a paid upgrade at every order value where the destination is supported, with the current upgrade price shown in the cart and at checkout. Ocean Shipping is free when selected on qualifying Ocean orders.',
      detail_url: '/policies/shipping-policy',
      detail_label: 'View Shipping Policy',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'ocean-shipping',
      question: 'What is Ocean Shipping?',
      category: 'orders-shipping',
      subcategory: 'Shipping',
      keywords: 'ocean shipping freight vessel 18 25 days 199 discount professional pricing restocking gifts',
      short_answer: 'Ocean Shipping is designed for planned restocking and bulk purchases. It appears on qualifying orders of $199+ after Professional Pricing, with 18-25 days after vessel departure, Extra 30% OFF, FREE Ocean Shipping, and FREE Florist Gifts.',
      detail_url: '/policies/shipping-policy',
      detail_label: 'Learn About Ocean Shipping',
      priority: 'high',
      show_on_contact: true,
      contact_order: 5
    },
    {
      id: 'track-order',
      question: 'How can I track my order?',
      category: 'orders-shipping',
      subcategory: 'Tracking & Orders',
      keywords: 'tracking track shipment package where is my order delivery status order status',
      short_answer: 'After your order ships, tracking information will be provided. Tracking activity may take several business days to update after the shipment is handed to the carrier, especially for international or Ocean Shipping orders.',
      detail_url: '/pages/contact?support=tracking',
      detail_label: 'Track My Order',
      priority: 'high',
      show_on_contact: true,
      contact_order: 3
    },
    {
      id: 'change-address',
      question: 'Can I change my shipping address?',
      category: 'orders-shipping',
      subcategory: 'Tracking & Orders',
      keywords: 'change address shipping address wrong address edit address',
      short_answer: 'Contact BBJ WRAPS as soon as possible with your order number. If the order has not shipped yet, the team can review whether the address can still be updated. Additional carrier fees caused by an incorrect or incomplete address may be charged to the customer.',
      detail_url: '/pages/contact',
      detail_label: 'Contact Support',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'change-cancel-order',
      question: 'Can I change or cancel my order?',
      category: 'orders-shipping',
      subcategory: 'Tracking & Orders',
      keywords: 'change cancel order modify edit remove item',
      short_answer: 'Please contact BBJ WRAPS quickly with your order number. If the order has already been processed or shipped, changes or cancellation may not be possible.',
      detail_url: '/pages/contact',
      detail_label: 'Contact Support',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'order-history',
      question: 'Where can I see my order history?',
      category: 'orders-shipping',
      subcategory: 'Tracking & Orders',
      keywords: 'order history previous orders account login purchase history',
      short_answer: 'Log in to your customer account to review your order history. If you checked out without an account, contact BBJ WRAPS with the email used for purchase.',
      detail_url: '/account',
      detail_label: 'Go to Account',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'wholesale-pricing',
      question: 'How do I get wholesale pricing?',
      category: 'wholesale-discounts',
      subcategory: 'Wholesale Pricing',
      keywords: 'wholesale pricing florist discount volume professional savings 139',
      short_answer: 'Orders of $139 or more qualify for BBJ WRAPS wholesale pricing. Eligible discounts are applied automatically in the cart according to the current cart logic.',
      detail_url: '/pages/wholesale#wholesale-pricing',
      detail_label: 'View Wholesale Pricing',
      priority: 'high',
      show_on_contact: true,
      contact_order: 2
    },
    {
      id: 'volume-discounts',
      question: 'How do volume discounts work?',
      category: 'wholesale-discounts',
      subcategory: 'Wholesale Pricing',
      keywords: 'volume discount professional pricing 15 30 40 50 cart automatic',
      short_answer: 'Current wholesale tiers shown on the site are 15% for orders $139+, 30% for orders $299+, 40% for orders $599+, and 50% for orders $999+. Discounts apply automatically in cart.',
      detail_url: '/pages/wholesale#wholesale-pricing',
      detail_label: 'View Wholesale Pricing',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'discount-not-apply',
      question: "Why didn't my discount apply?",
      category: 'wholesale-discounts',
      subcategory: 'Wholesale Pricing',
      keywords: 'discount did not apply coupon code wholesale automatic cart problem threshold',
      short_answer: 'Wholesale thresholds are based on order value and current cart logic. If your cart appears eligible but the discount is not showing, contact support with a screenshot and your cart details so the team can review it.',
      detail_url: '/pages/contact',
      detail_label: 'Contact Support',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'ocean-discount',
      question: 'How does the Ocean Shipping discount work?',
      category: 'wholesale-discounts',
      subcategory: 'Wholesale Pricing',
      keywords: 'ocean shipping discount 30 off professional pricing sequential 199 gifts',
      short_answer: 'Professional Pricing applies first. If Ocean Shipping is selected, the extra 30% Ocean savings apply to the remaining merchandise subtotal. Ocean eligibility is calculated after Professional Pricing.',
      detail_url: '/policies/shipping-policy',
      detail_label: 'View Shipping Policy',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'choose-product',
      question: 'How do I choose the right product?',
      category: 'products-availability',
      subcategory: 'Product Help',
      keywords: 'choose product material size color wrap bag box ribbon florist',
      short_answer: 'Use the product details, images, and collection categories to compare material, size, color, and use case. If you are unsure, send BBJ WRAPS the product URL and your bouquet or packaging use case.',
      detail_url: '/pages/contact',
      detail_label: 'Ask a Product Question',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'out-of-stock',
      question: 'The product I want is out of stock. What should I do?',
      category: 'products-availability',
      subcategory: 'Product Help',
      keywords: 'out of stock restock unavailable sold out notify',
      short_answer: 'Contact BBJ WRAPS with the product name or product URL. The team can help check restock timing or suggest a similar option.',
      detail_url: '/pages/contact',
      detail_label: 'Contact Support',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'color-material-help',
      question: 'Can you help with color, size, or material questions?',
      category: 'products-availability',
      subcategory: 'Product Help',
      keywords: 'color size material dimensions product question compare',
      short_answer: 'Yes. Send the product name or URL, the color or size you are considering, and how you plan to use it. Product photos are also helpful for matching or comparison questions.',
      detail_url: '/pages/contact',
      detail_label: 'Ask a Product Question',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'custom-printing',
      question: 'Do you offer custom printing?',
      category: 'custom-printing-orders',
      subcategory: 'Custom Orders',
      keywords: 'custom printing printed packaging logo private label design',
      short_answer: 'Yes. BBJ WRAPS can review custom printing or custom packaging requests. Share the product type, estimated quantity, desired size/material, deadline, and any logo or reference image.',
      detail_url: '/pages/contact',
      detail_label: 'Request a Custom Quote',
      priority: 'high',
      show_on_contact: true,
      contact_order: 4
    },
    {
      id: 'print-logo',
      question: 'Can you print my logo?',
      category: 'custom-printing-orders',
      subcategory: 'Custom Orders',
      keywords: 'logo print printing brand custom packaging artwork',
      short_answer: 'BBJ WRAPS can review logo printing requests. Send your logo file or reference image, the product type, estimated quantity, and deadline so the team can confirm feasibility.',
      detail_url: '/pages/contact',
      detail_label: 'Request a Custom Quote',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'custom-quote',
      question: 'How do I request a custom quote?',
      category: 'custom-printing-orders',
      subcategory: 'Custom Orders',
      keywords: 'quote custom order estimate printing deadline quantity',
      short_answer: 'Use the Contact Us page and select Custom Printing. Include product type, estimated quantity, desired size/material, deadline, message, and optional logo or reference image.',
      detail_url: '/pages/contact',
      detail_label: 'Request a Custom Quote',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'samples-offered',
      question: 'Do you offer samples?',
      category: 'samples',
      subcategory: 'Samples',
      keywords: 'samples sample request material color before order',
      short_answer: 'Yes. You can request samples to review materials and colors before placing a larger wholesale order. Share the products you are interested in and your estimated order size or monthly purchase.',
      detail_url: '/pages/contact',
      detail_label: 'Request Samples',
      priority: 'high',
      show_on_contact: true,
      contact_order: 6
    },
    {
      id: 'sample-shipping-cost',
      question: 'How much does sample shipping cost?',
      category: 'samples',
      subcategory: 'Samples',
      keywords: 'sample shipping sample delivery free samples sample cost standard shipping sample express sample',
      short_answer: 'Samples are free. If samples are shipped together with your order, there is no additional sample shipping charge. If you request samples separately, shipping is charged by the available delivery method, such as Standard Shipping or Express Shipping.',
      detail_url: '/pages/contact',
      detail_label: 'Request Samples',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'sample-before-wholesale',
      question: 'Can I request samples before a wholesale order?',
      category: 'samples',
      subcategory: 'Samples',
      keywords: 'samples wholesale sample before large order florist',
      short_answer: 'Yes. Samples are useful when you need to confirm material, color, and style before a larger wholesale order. Include your company or florist name, country, products of interest, and estimated order size.',
      detail_url: '/pages/contact',
      detail_label: 'Request Samples',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'sample-help',
      question: 'What should I include in a sample request?',
      category: 'samples',
      subcategory: 'Samples',
      keywords: 'sample request what include company country products order size',
      short_answer: 'Include your name, email, company or florist name, country, products you are interested in, and estimated order size or monthly purchase.',
      detail_url: '/pages/contact',
      detail_label: 'Request Samples',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'delivered-not-received',
      question: "Tracking says delivered, but I haven't received it",
      category: 'order-issues-returns',
      subcategory: 'Order Issues',
      keywords: 'tracking delivered not received missing package lost delivery issue',
      short_answer: 'First check the tracking details, delivery location, and nearby safe places. If you still cannot find the package, contact BBJ WRAPS with your order number and tracking information.',
      detail_url: '/pages/contact',
      detail_label: 'Contact Support',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'damaged-wrong-item',
      question: 'What should I do if an item is damaged, wrong, or missing?',
      category: 'order-issues-returns',
      subcategory: 'Order Issues',
      keywords: 'damaged wrong item missing shortage order issue image upload',
      short_answer: 'Contact BBJ WRAPS with your order number, issue type, description, and photos if available. The Contact Us page includes an Order Issues form for this.',
      detail_url: '/pages/contact',
      detail_label: 'Submit Order Issue',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'return-policy',
      question: 'What is your return policy?',
      category: 'order-issues-returns',
      subcategory: 'Order Issues',
      keywords: 'return returns refund policy exchange damaged lost unwanted',
      short_answer: 'Please review the current Refund Policy for return and refund eligibility. If your item arrived damaged, wrong, or missing, contact support with your order number and photos where possible.',
      detail_url: '/policies/refund-policy',
      detail_label: 'View Refund Policy',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'account-access',
      question: 'How do I access my account?',
      category: 'account-reordering',
      subcategory: 'Account',
      keywords: 'account login sign in access email password',
      short_answer: 'Use the account link to log in with the email connected to your orders. If you have trouble accessing your account, contact BBJ WRAPS with your purchase email.',
      detail_url: '/account',
      detail_label: 'Go to Account',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'reorder-products',
      question: 'Can I reorder products from a previous order?',
      category: 'account-reordering',
      subcategory: 'Account',
      keywords: 'reorder previous order buy again repeat purchase',
      short_answer: 'You can use your account order history or previous order emails to find products again. If you need help identifying an item, send BBJ WRAPS the order number or product photo.',
      detail_url: '/account',
      detail_label: 'Go to Account',
      priority: 'normal',
      show_on_contact: false
    },
    {
      id: 'saved-addresses',
      question: 'Can I manage saved addresses?',
      category: 'account-reordering',
      subcategory: 'Account',
      keywords: 'saved address manage address account shipping address',
      short_answer: 'Saved addresses can be managed from your account address book. Always confirm the shipping address at checkout before placing a new order.',
      detail_url: '/account/addresses',
      detail_label: 'Manage Addresses',
      priority: 'normal',
      show_on_contact: false
    }
  ];

  const byId = new Map(faqs.map((faq) => [faq.id, faq]));
  window.BBJ_HELP_CENTER_DATA = { topics, faqs };

  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  }[char]));

  const slug = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

  const scoreFaq = (faq, query) => {
    const q = query.trim().toLowerCase();
    if (!q) return 0;
    const haystack = [
      faq.question,
      faq.category,
      faq.subcategory,
      faq.keywords,
      faq.short_answer
    ].join(' ').toLowerCase();
    if (faq.question.toLowerCase().includes(q)) return 100;
    if (faq.keywords.toLowerCase().includes(q)) return 70;
    return q.split(/\s+/).reduce((score, term) => score + (haystack.includes(term) ? 18 : 0), 0);
  };

  const searchFaqs = (query) => faqs
    .map((faq) => ({ faq, score: scoreFaq(faq, query) }))
    .filter((item) => item.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, 8)
    .map((item) => item.faq);

  const renderAnswer = (faq) => `
    <div class="bbj-help-answer">
      <p>${escapeHtml(faq.short_answer)}</p>
      ${faq.detail_url ? `<a href="${escapeHtml(faq.detail_url)}">${escapeHtml(faq.detail_label || 'Learn More')} <span aria-hidden="true">-&gt;</span></a>` : ''}
    </div>
  `;

  const initHelpCenter = (root) => {
    if (root.dataset.helpReady === 'true') return;
    root.dataset.helpReady = 'true';

    const topicList = root.querySelector('[data-help-topic-list]');
    const content = root.querySelector('[data-help-content]');
    const searchInput = root.querySelector('[data-help-search]');
    const searchResults = root.querySelector('[data-help-search-results]');
    const clearButton = root.querySelector('[data-help-search-clear]');
    let activeTopic = topics[0].id;

    const renderTopicList = () => {
      topicList.innerHTML = topics.map((topic) => `
        <button class="bbj-help-topic${topic.id === activeTopic ? ' is-active' : ''}" type="button" data-help-topic="${topic.id}" aria-current="${topic.id === activeTopic ? 'true' : 'false'}">
          <span class="bbj-help-topic__icon" aria-hidden="true">${escapeHtml(topic.icon)}</span>
          <span class="bbj-help-topic__label">${escapeHtml(topic.title)}</span>
          <span class="bbj-help-topic__arrow" aria-hidden="true">&gt;</span>
        </button>
      `).join('');
    };

    const renderTopic = (topicId) => {
      const topic = topics.find((item) => item.id === topicId) || topics[0];
      activeTopic = topic.id;
      renderTopicList();
      root.classList.add('is-topic-open');
      content.innerHTML = `
        <article class="bbj-help-topic-view">
          <button class="bbj-help-back" type="button" data-help-back>&lt; Back to all topics</button>
          <header class="bbj-help-topic-view__head">
            <h2>${escapeHtml(topic.title)}</h2>
            <p>${escapeHtml(topic.description)}</p>
          </header>
          ${topic.groups.map((group) => `
            <section class="bbj-help-group" aria-label="${escapeHtml(group.title)}">
              <h3>${escapeHtml(group.title)}</h3>
              ${group.items.map((faqId) => {
                const faq = byId.get(faqId);
                if (!faq) return '';
                return `
                  <details class="bbj-help-item" id="${escapeHtml(faq.id)}" data-help-faq-id="${escapeHtml(faq.id)}">
                    <summary><span>${escapeHtml(faq.question)}</span><span class="bbj-help-item__plus" aria-hidden="true">+</span></summary>
                    ${renderAnswer(faq)}
                  </details>
                `;
              }).join('')}
            </section>
          `).join('')}
        </article>
      `;
    };

    const showSearchResults = (query) => {
      const results = searchFaqs(query);
      clearButton.hidden = !query;
      if (!query) {
        searchResults.hidden = true;
        searchResults.innerHTML = '';
        return;
      }
      searchResults.hidden = false;
      searchResults.innerHTML = results.length ? results.map((faq) => {
        const topic = topics.find((item) => item.id === faq.category);
        return `
          <button class="bbj-help-search__result" type="button" data-help-result="${escapeHtml(faq.id)}">
            <strong>${escapeHtml(faq.question)}</strong>
            <span>${escapeHtml(topic ? topic.title : faq.subcategory)}</span>
          </button>
        `;
      }).join('') : '<div class="bbj-help-search__empty">No matching answers found. Try shipping, wholesale, tracking, returns, logo, or samples.</div>';
    };

    const openFaq = (faqId, updateHash = true) => {
      const faq = byId.get(faqId);
      if (!faq) return;
      renderTopic(faq.category);
      requestAnimationFrame(() => {
        const item = content.querySelector(`[data-help-faq-id="${CSS.escape(faq.id)}"]`);
        if (!item) return;
        item.open = true;
        item.classList.add('is-target');
        item.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(() => item.classList.remove('is-target'), 1800);
        if (updateHash) history.replaceState(null, '', `#${slug(faq.id)}`);
      });
    };

    topicList.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-help-topic]');
      if (!trigger) return;
      renderTopic(trigger.dataset.helpTopic);
      if (window.matchMedia('(max-width: 749px)').matches) {
        content.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    content.addEventListener('click', (event) => {
      const back = event.target.closest('[data-help-back]');
      if (!back) return;
      root.classList.remove('is-topic-open');
      root.querySelector('.bbj-help-sidebar').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    searchInput.addEventListener('input', () => showSearchResults(searchInput.value));

    searchResults.addEventListener('click', (event) => {
      const result = event.target.closest('[data-help-result]');
      if (!result) return;
      searchResults.hidden = true;
      openFaq(result.dataset.helpResult);
    });

    clearButton.addEventListener('click', () => {
      searchInput.value = '';
      showSearchResults('');
      searchInput.focus();
    });

    root.querySelectorAll('[data-help-popular]').forEach((button) => {
      button.addEventListener('click', () => {
        searchInput.value = button.dataset.helpPopular;
        showSearchResults(searchInput.value);
        const results = searchFaqs(searchInput.value);
        if (results[0]) openFaq(results[0].id);
      });
    });

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) searchResults.hidden = true;
    });

    renderTopic(activeTopic);

    if (window.location.hash) {
      const target = window.location.hash.replace('#', '');
      const match = faqs.find((faq) => slug(faq.id) === target || slug(faq.question) === target);
      if (match) window.setTimeout(() => openFaq(match.id, false), 150);
    }
  };

  const initContactFaq = (root) => {
    if (root.dataset.contactFaqReady === 'true') return;
    root.dataset.contactFaqReady = 'true';
    const contactFaqs = faqs
      .filter((faq) => faq.show_on_contact)
      .sort((a, b) => (a.contact_order || 99) - (b.contact_order || 99))
      .slice(0, 6);

    root.innerHTML = `
      <h2>Most Asked Questions</h2>
      ${contactFaqs.map((faq) => `
        <details class="bbj-support-faq-item">
          <summary><span>${escapeHtml(faq.question)}</span><span aria-hidden="true">+</span></summary>
          <div class="bbj-support-faq-answer">
            <p>${escapeHtml(faq.short_answer)}</p>
            ${faq.id === 'track-order'
              ? `<button type="button" data-support-open="tracking">${escapeHtml(faq.detail_label || 'Track My Order')} <span aria-hidden="true">-&gt;</span></button>`
              : (faq.detail_url ? `<a href="${escapeHtml(faq.detail_url)}">${escapeHtml(faq.detail_label || 'Learn More')} -&gt;</a>` : '')}
          </div>
        </details>
      `).join('')}
      <a class="bbj-support-faq__all" href="/pages/frequently-asked-questions">View All FAQs</a>
    `;
  };

  const init = () => {
    document.querySelectorAll('[data-bbj-help-center]').forEach(initHelpCenter);
    document.querySelectorAll('[data-bbj-faq-contact]').forEach(initContactFaq);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
